<template>
  <div v-if="detailsData.data">
    <div class="Wcenter">
      <div class="top">
        <img v-lazy="`${$global.imgUrl}/${detailsData.data.cover}`" alt="" />
        <div>
          <h1 v-if="detailsData.data.reportName" class="title">
            {{ detailsData.data.reportName }}
          </h1>
          <div v-if="detailsData.data.englishName" class="tips">
            {{ detailsData.data.englishName }}
          </div>
        </div>
      </div>
      <ul class="content">
        <li v-if="detailsData.data.reportCode">
          <span class="key">报告编号:</span
          ><span class="value">{{ detailsData.data.reportCode }}</span>
        </li>
        <!--        <li><span class="key">出版日期:</span><span class="value">{{detailsData.data.reportCode }}</span></li>-->
        <li v-if="detailsData.data.reportNumber">
          <span class="key">图表数量:</span
          ><span class="value">{{ detailsData.data.reportNumber }}</span>
        </li>
        <li v-if="detailsData.data.sendWay">
          <span class="key">寄送方式:</span
          ><span class="value">{{ detailsData.data.sendWay }}</span>
        </li>
        <li v-if="detailsData.data.chinesePrice">
          <span class="key">中文版全价:</span
          ><span class="value">{{ detailsData.data.chinesePrice }}</span>
        </li>
        <li v-if="detailsData.data.electronicPrice">
          <span class="key">中文电子版:</span
          ><span class="value">{{ detailsData.data.electronicPrice }}</span>
        </li>
        <li v-if="detailsData.data.printingPrice">
          <span class="key">中文印刷版:</span
          ><span class="value">{{ detailsData.data.printingPrice }}</span>
        </li>
        <li v-if="detailsData.data.englishPrice">
          <span class="key">英文版全价:</span
          ><span class="value">{{ detailsData.data.englishPrice }}</span>
        </li>
        <li v-if="detailsData.data.electronicEnglishPrice">
          <span class="key">英文电子版:</span
          ><span class="value">{{
            detailsData.data.electronicEnglishPrice
          }}</span>
        </li>
        <li v-if="detailsData.data.printingEnglishPrice">
          <span class="key">英文印刷版:</span
          ><span class="value">{{
            detailsData.data.printingEnglishPrice
          }}</span>
        </li>
      </ul>
    </div>
    <div class="Wbottom">
      <div class="nav">
        <div @click="changeAct(0)" :class="act === 0 ? 'active' : ''">
          目录
          <span v-show="act === 0" class="xian"></span>
        </div>
        <div @click="changeAct(1)" :class="act === 1 ? 'active' : ''">
          报告导读
          <span v-show="act === 1" class="xian"></span>
        </div>
      </div>
      <div class="mulu" v-show="act === 0">
        <div class="oneUl" v-html="detailsData.data.catalogue"></div>
      </div>
      <div class="daodu" v-show="act === 1">
        <div class="oneUl" v-html="detailsData.data.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["detailsData"],
  name: "center",
  data() {
    return {
      act: 0,
    };
  },
  mounted() {
    // this.detailsData.catalogue.split('/n')
  },
  methods: {
    changeAct(i) {
      this.act = i;
    },
  },
};
</script>

<style lang="scss" scoped>
.Wcenter {
  width: 792px;
  //height: 513px;
  padding: 32px 34px 45px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);

  .content {
    width: 830px;
    margin: 33px auto 0;

    li {
      margin-top: 5px;

      .key {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        //background: yellow;
        color: #333333;
        margin-right: 12px;
      }

      .value {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
  }

  .top {
    display: flex;
    //justify-content: space-between;
    img {
      width: 100px;
      height: 130px;
      //background: pink;
      //float: left;
    }

    .title {
      //float: left;
      margin-left: 11px;
      font-size: 30px;
      font-weight: bold;
      color: #263d78;
    }

    .tips {
      margin-left: 11px;
      //width: 666px;
      //height: 16px;
      font-size: 14px;
      //font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333 !important;
      line-height: 30px;
    }
  }
}

.Wbottom {
  width: 792px;
  margin-top: 10px;
  padding: 34px;
  //height: 803px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);

  .nav {
    display: flex;
    cursor: pointer;
    div {
      margin-right: 50px;
      width: 80px;
      height: 20px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
    }

    .active {
      width: 80px;
      height: 20px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0b35c5;
      line-height: 24px;
      position: relative;
    }

    .xian {
      position: absolute;
      width: 40px;
      left: 0;
      bottom: -10px;
      height: 3px;
      background: #0b35c5;
      border-radius: 1px;
    }
  }

  .daodu {
    margin-top: 40px;
    //text-indent: 30px;
    min-height: 400px;
  }

  .mulu {
    .oneUl {
      margin-top: 40px;

      .oneLi {
        width: 160px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
        //position: relative;
        .zhang {
          margin-right: 10px;
        }

        .zhangContent {
        }

        .twoUl {
          margin-left: 32px;
          margin-top: 30px;
          margin-bottom: 50px;
          //position: absolute;
          //right: 0;
          li {
            width: 197px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 36px;
          }

          .jie {
            margin-right: 10px;
          }

          .jieContent {
          }
        }
      }
    }
  }
}
</style>
